import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({
  comic,
  showMeta = true,
}: {
  comic: Comic;
  showMeta?: boolean;
}) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col gap-2"
      aria-label={`阅读《${comic.title}》漫画`}
    >
      <div className="relative w-full overflow-hidden rounded-xl bg-background-100">
        <div className="aspect-[3/4] w-full">
          <img
            src={comic.cover}
            alt={`《${comic.title}》漫画封面`}
            title={`《${comic.title}》漫画在线免费阅读`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
          {comic.status}
        </div>
        {showMeta && (
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-2 pt-7">
            <p className="truncate text-xs text-background-50">
              {comic.latestChapter}
            </p>
          </div>
        )}
      </div>
      <div>
        <h3 className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600">
          {comic.title}
        </h3>
        {showMeta && (
          <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
            <span className="flex items-center gap-0.5 text-accent-600">
              <i className="ri-star-fill text-xs"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-0.5">
              <i className="ri-eye-line text-xs"></i>
              {comic.views}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}